var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import SVGPathCommander from "svg-path-commander";
import { css, html, LitElement, svg } from "lit";
import { customElement, property, state } from "lit/decorators.js";
const customEl = "svg-trait";
let SVGTrait = class SVGTrait extends LitElement {
    constructor() {
        super(...arguments);
        this.height = 1000;
        this.width = 1000;
        this.strokeWidth = 3;
        /*
    
          a         b
           ╭───────╮
           │       │
           │       │
           │       │
           ╰───────╯
          c         d
    
        */
        this.Corner = {
            a: ["c", 0, -4, 4, -8, 8, -8], // correct
            b: ["c", 4, 0, 8, 4, 8, 8], // correct
            c: ["c", 0, 4, 4, 8, 8, 8], // correct
            d: ["c", 0, -4, -4, -8, -8, -8],
        };
        this.RCorner = {
            a: ["c", -4, 0, -8, 4, -8, 8], // correct
            b: ["c", 0, -4, -4, -8, -8, -8], // correct
            c: ["c", -4, 0, -8, -4, -8, -8], // correct
            d: ["c", 0, 4, -4, 8, -8, 8], // correct
        };
    }
    circle(position, path) {
        const length = SVGPathCommander.getTotalLength(path.d);
        const { x, y } = SVGPathCommander.getPointAtLength(path.d, position === "start" ? 0 : length);
        const attributes = {
            type: "circle",
            cx: x,
            cy: y,
            r: this.strokeWidth,
            fill: "currentColor",
            strokeWidth: 0,
        };
        return svg `<circle cx="${attributes.cx}" cy="${attributes.cy}" r="${attributes.r}" fill="${attributes.fill}" stroke="${attributes.stroke}" stroke-width="${attributes.strokeWidth}"/>`;
    }
    path(attributes) {
        return svg `<path d="${attributes.d}" fill="${attributes.fill}" stroke="${attributes.stroke}" stroke-width="${attributes.strokeWidth}" vector-effect="non-scaling-stroke"/>`;
    }
    Feat() {
        const leftPathArray = [
            ["m", 35, Math.ceil(.75 * this.height)],
            ["h", -10],
            this.RCorner.a,
            ["v", 50],
            this.RCorner.d,
            ["h", -(35 + 10)],
        ];
        const leftPathAttr = {
            type: "path",
            d: SVGPathCommander.pathToString(leftPathArray),
            fill: "none",
            stroke: "currentColor",
            strokeWidth: this.strokeWidth,
        };
        const rightPathArray = [
            ["m", this.width, Math.ceil(.15 * this.height)],
            ["h", -25],
            this.RCorner.a,
            ["v", Math.ceil(.35 * this.height)],
            this.RCorner.d,
            ["h", -25],
        ];
        const rightPathAttr = {
            type: "path",
            d: SVGPathCommander.pathToString(rightPathArray),
            fill: "none",
            stroke: "currentColor",
            strokeWidth: this.strokeWidth,
        };
        return html `
            ${this.path(leftPathAttr)}
            ${this.circle("start", leftPathAttr)}
            ${this.path(rightPathAttr)}
            ${this.circle("end", rightPathAttr)}
        `;
    }
    Cards() {
        const leftPathArray = [
            ["m", 150, Math.ceil(.5 * this.height)],
            ["h", -25],
            this.RCorner.a,
            ["v", 100],
            this.RCorner.d,
            ["h", -(150 + 25)],
        ];
        const leftPathAttr = {
            type: "path",
            d: SVGPathCommander.pathToString(leftPathArray),
            fill: "none",
            stroke: "currentColor",
            strokeWidth: this.strokeWidth,
        };
        const rightPathArray = [
            ["m", 675, Math.ceil(.225 * this.height)],
            ["v", -25],
            this.Corner.a,
            ["h", this.width - 675],
        ];
        const rightPathAttr = {
            type: "path",
            d: SVGPathCommander.pathToString(rightPathArray),
            fill: "none",
            stroke: "currentColor",
            strokeWidth: this.strokeWidth,
        };
        return html `
            ${this.path(leftPathAttr)}
            ${this.circle("start", leftPathAttr)}
            ${this.path(rightPathAttr)}
            ${this.circle("start", rightPathAttr)}
        `;
    }
    Damier() {
        const leftPathArray = [
            ["m", 0, 5],
            ["h", 240],
            this.Corner.b,
            ["v", 10],
        ];
        const leftPathAttr = {
            type: "path",
            d: SVGPathCommander.pathToString(leftPathArray),
            fill: "none",
            stroke: "currentColor",
            strokeWidth: this.strokeWidth,
        };
        const rightPathArray = [
            ["m", this.width, Math.ceil(.9 * this.height)],
            ["h", -25],
            this.RCorner.c,
            ["v", -Math.ceil(.35 * this.height)],
            this.RCorner.b,
            ["h", -40],
        ];
        const rightPathAttr = {
            type: "path",
            d: SVGPathCommander.pathToString(rightPathArray),
            fill: "none",
            stroke: "currentColor",
            strokeWidth: this.strokeWidth,
        };
        return html `
            ${this.path(leftPathAttr)}
            ${this.circle("end", leftPathAttr)}
            ${this.path(rightPathAttr)}
            ${this.circle("end", rightPathAttr)}
        `;
    }
    Hero() {
        const Hero = {
            _trait: this,
            startX: 25,
            startY: 150,
            leftHWidth: 50,
            leftVHeight: 100,
            centerWidth: 825,
            rightVHeight: 100,
            get rightHWidth() {
                return this._trait.width - this.startX - this.leftHWidth -
                    this.centerWidth;
            },
        };
        const pathArray = [
            ["m", Hero.startX, Hero.startY],
            ["h", Hero.leftHWidth],
            ["c", 4, 0, 8, 4, 8, 8],
            ["v", Hero.leftVHeight],
            ["c", 0, 4, 4, 8, 8, 8],
            ["h", Hero.centerWidth],
            ["c", 4, 0, 8, 4, 8, 8],
            ["v", Hero.rightVHeight],
            ["c", 0, 4, 4, 8, 8, 8],
            ["h", Hero.rightHWidth],
        ];
        const pathAttr = {
            type: "path",
            d: SVGPathCommander.pathToString(pathArray),
            fill: "none",
            stroke: "currentColor",
            strokeWidth: this.strokeWidth,
        };
        const pathEl = this.path(pathAttr);
        const circAttr = {
            type: "circle",
            cx: Hero.startX,
            cy: Hero.startY,
            r: this.strokeWidth,
            fill: "currentColor",
            strokeWidth: 0,
        };
        return html `
            ${pathEl}
            ${SVGPathCommander.shapeToPath(circAttr)}
        `;
    }
    getRealHeight() {
        const height = this.shadowRoot?.host.getBoundingClientRect().height ||
            1000;
        const width = this.shadowRoot?.host.getBoundingClientRect().width ||
            1000;
        this.height = Math.ceil(height * 1000 / width);
    }
    connectedCallback() {
        super.connectedCallback();
        this.getRealHeight();
        this.observer = new ResizeObserver(this.throttle(this.getRealHeight, 250));
        this.observer?.observe(document.body);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.observer?.disconnect();
    }
    // @ts-ignore
    throttle(func, wait) {
        let timeout;
        let previous = 0;
        return (...args) => {
            const now = Date.now();
            const remaining = wait - (now - previous);
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = undefined;
                }
                previous = now;
                func.apply(this, args);
            }
            else if (!timeout) {
                timeout = setTimeout(() => {
                    previous = Date.now();
                    timeout = undefined;
                    func.apply(this, args);
                }, remaining);
            }
        };
    }
    render() {
        const svgEl = (content) => html `<svg viewBox="0 0 ${this.width} ${this.height}" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" aria-hidden="true">${content}</svg>`;
        switch (this.which) {
            case "hero":
                return svgEl(this.Hero());
            case "damier":
                return svgEl(this.Damier());
            case "cards":
                return svgEl(this.Cards());
            case "feat":
                return svgEl(this.Feat());
            default:
                return;
        }
    }
};
SVGTrait.styles = css `
        :host {
            user-select: none;
            pointer-events: none;

            @media (max-width: 1024px) {
                display: none;
            }
        }
        svg {
            width: 100%;
            height: 100%;
        }
    `;
__decorate([
    property({ type: String }),
    __metadata("design:type", String)
], SVGTrait.prototype, "which", void 0);
__decorate([
    state(),
    __metadata("design:type", Object)
], SVGTrait.prototype, "height", void 0);
__decorate([
    state(),
    __metadata("design:type", ResizeObserver)
], SVGTrait.prototype, "observer", void 0);
SVGTrait = __decorate([
    customElement(customEl)
], SVGTrait);
export { SVGTrait };
